import React, { useEffect } from "react"
import { Button } from "react-bootstrap"
import logo from "../../resource/img/PGLogo.png"

function Redirect(props) {
   function handleLogInPing() {
      localStorage.setItem("userType", "PG")
      let authUrl =
         `${process.env.REACT_APP_AUTH_URI}/as/authorization.oauth2?` +
         `response_type=${process.env.REACT_APP_responseType}&` +
         `client_id=${process.env.REACT_APP_clientId}&` +
         `scope=${process.env.REACT_APP_scope}&` +
         `display_name=${process.env.REACT_APP_display_name}&` +
         `redirect_uri=${process.env.REACT_APP_redirectUri}` +
         `&state=/tokens/authcode`

      window.location.href = authUrl
   }

   function handleLogInJagger() {
      localStorage.setItem("userType", "SBM")
      let authUrl =
         `${process.env.REACT_APP_JAGGER_AUTH_URI}?` +
         `response_type=${process.env.REACT_APP_responseType}&` +
         `scope=${process.env.REACT_APP_JAGGER_SCOPE}&` +
         `client_id=${process.env.REACT_APP_JAGGER_CLIENTID}&` +
         `redirect_uri=${process.env.REACT_APP_redirectUri}&` +
         `state=/tokens/authcode`
      window.location.href = authUrl
   }

   useEffect(() => {
   let gcas = ""
   let objectName = ""
   let downloadtype = ""
   let unreleasedPartName = ""
   
   // Handle GCAS scenario
   if (localStorage.getItem("calledFrom") && localStorage.getItem("calledFrom") === "gcas") {
      gcas = localStorage.getItem("gcas") || ""
   }
   
   // Handle objectName scenario
   if (localStorage.getItem("calledFrom") && localStorage.getItem("calledFrom") === "objectName") {
      objectName = localStorage.getItem("objectName") || ""
   }
   
   // Handle downloadtype scenario
   if (localStorage.getItem("calledFrom1") && localStorage.getItem("calledFrom1") === "downloadtype") {
      downloadtype = localStorage.getItem("downloadtype") || ""
   }

   // Handle unreleasedSearch scenario
   if (localStorage.getItem("calledFrom") && localStorage.getItem("calledFrom") === "unreleasedSearch") {
      unreleasedPartName = localStorage.getItem("unreleasedPartName") || ""
   }
   
   localStorage.removeItem("id_token")
   localStorage.removeItem("User")
   localStorage.clear()
   sessionStorage.clear()
   
   // Restore with proper context flags
   if (gcas) {
      localStorage.setItem("calledFrom", "gcas")
      localStorage.setItem("gcas", gcas)
   }
   
   if (objectName) {
      localStorage.setItem("calledFrom1", "objectName")
      localStorage.setItem("objectName", objectName)
   }
   
   if (downloadtype) {
      localStorage.setItem("calledFrom2", "downloadtype")
      localStorage.setItem("downloadtype", downloadtype)
   }

   if (unreleasedPartName) {
      localStorage.setItem("calledFrom", "unreleasedSearch")
      localStorage.setItem("unreleasedPartName", unreleasedPartName)
   }
   
   // ✅ PREVENT BACK BUTTON NAVIGATION - WITHOUT beforeunload
   window.history.pushState(null, "", window.location.href)
   window.history.pushState(null, "", window.location.href)
   
   const preventBackNavigation = () => {
      window.history.pushState(null, "", window.location.href)
   }
   
   window.addEventListener("popstate", preventBackNavigation)
   
   // Cleanup on component unmount
   return () => {
      window.removeEventListener("popstate", preventBackNavigation)
   }
}, [])

   return (
      <React.Fragment>
         <div className="signInContainer">
            <div className="signInBox">
               <div className="signInImageContainer">
                  <img src={logo} className="signInImage" alt="P&G Logo" />
               </div>
               <h2 className="signInText">Sign in to SpecReader</h2>
               <Button
                  className="signInButton"
                  style={{ marginTop: "20%" }}
                  onClick={handleLogInPing}
               >
                  Sign In with PINGID
               </Button>
               <Button
                  className="signInButton"
                  style={{ marginTop: "7vh" }}
                  onClick={handleLogInJagger}
               >
                  Sign In with JAGGAER (SBM)
               </Button>
            </div>
         </div>
      </React.Fragment>
   )
}

export default Redirect